<template>
  <div>
    <v-tabs>
      <v-tab href="#tab-1">{{ $t('quotation_item_tab_item') }}</v-tab>
      <v-tab href="#tab-2">{{ $t('quotation_item_tab_pay_item') }}</v-tab>
      <v-tab-item value="tab-1">
        <v-card flat>
          <v-card-text>
            <v-data-table
              :headers="offsetItemDataTableHeaders"
              :items="computedOffsetItemList"
              :search="searchOffsetItem"
              class="elevation-1"
              :no-data-text="$t('common_no_data')"
              :no-results-text="$t('common_no_results')"
              disable-pagination
              hide-default-footer
              item-key="Index"
              show-select
              v-model="selectedOffsetItems"
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="searchOffsetItem"
                    append-icon="mdi-magnify"
                    :label="$t('quotation_item_new_install_search')"
                    single-line
                    hide-details
                    clearable
                  >
                  </v-text-field>
                  <v-btn
                    color="primary"
                    class="mb-2 ml-8"
                    @click="deleteOffsetItems"
                    :disabled="isAllTextFieldDisabled || selectedOffsetItems.length === 0"
                  >
                    {{ $t('common_delete') }}
                  </v-btn>
                  <v-btn
                    color="primary"
                    class="mb-2 ml-8"
                    @click="isShowEditOffsetItemDialog = true"
                    :disabled="isAllTextFieldDisabled || quotationNumberType === numberType.Repair"
                  >
                    {{ $t('common_new') }}
                  </v-btn>
                  <v-dialog
                    v-model="isShowEditOffsetItemDialog"
                    v-if="isShowEditOffsetItemDialog"
                    persistent
                  >
                    <v-card>
                      <v-card-title>
                        <span class="text-h5">{{ title }}</span>
                      </v-card-title>
                      <v-card-text>
                        <v-container>
                          <ValidationObserver ref="dialog">
                            <v-row>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <v-checkbox
                                  v-model="editedOffsetItem.IsCustomerDevice"
                                  :label="$t('quotation_item_is_customer_device')"
                                  @change="changeIsCustomerDevice"
                                ></v-checkbox>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <v-autocomplete
                                  v-model="editedOffsetItem.CustomerDeviceType"
                                  :items="computedItemCustomerDeviceTypeList"
                                  item-text="Name"
                                  item-value="Type"
                                  :label="$t('engineer_item_customer_device_type')"
                                  :loading-text="$t('common_get_data')"
                                  :no-data-text="$t('common_no_results')"
                                  v-if="editedOffsetItem.IsCustomerDevice"
                                  ref="customerDeviceTypeAutocomplete"
                                  @keyup.enter="setCustomerDevice"
                                ></v-autocomplete>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <quotation-item-for-repair-price-autocomplete
                                  :fatherEditedItem="editedOffsetItem"
                                  :editedItemIndex="editedOffsetItemIndex"
                                  :itemName="'quotation_item_number'"
                                  :repairCustomerId="customerId"
                                  :customerDeviceType="editedOffsetItem.CustomerDeviceType"
                                  @setEditedItem="setEditedItem"
                                  v-if="editedOffsetItemIndex === -1"
                                  @keyupEnter="focusNextInput"
                                  refName="quotationItemAutocomplete"
                                />
                                <ValidationProvider
                                  :name="$t('quotation_item_number')"
                                  rules="required"
                                  v-slot="{ errors }"
                                  v-else
                                >
                                  <v-text-field
                                    v-model="editedOffsetItem.Number"
                                    disabled
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_number') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_name')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedOffsetItem.Name"
                                    :label="$t('quotation_item_name')"
                                    disabled
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_name') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_unit')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedOffsetItem.Unit"
                                    disabled
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_unit') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_quantity')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedOffsetItem.Quantity"
                                    :error-messages="errors[0]"
                                    @change="changeMoney"
                                    @keyup.enter="focusNextInput"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_quantity') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('installation_notice_item_buy_or_rent')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-autocomplete
                                    v-model="editedOffsetItem.BuyOrRentType"
                                    :items="allBuyOrRentType"
                                    item-text="Name"
                                    item-value="Type"
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('installation_notice_item_buy_or_rent') }}
                                    </template>
                                  </v-autocomplete>
                                </ValidationProvider>
                              </v-col>
                              <v-col
                                cols="12"
                                sm="6"
                                md="4"
                                lg="3"
                                xl="3"
                                v-if="
                                  editedOffsetItem.HasSerialNumber &&
                                    editedOffsetItem.SerialNumber &&
                                    editedOffsetItem.SerialNumber.Number
                                "
                              >
                                <v-text-field
                                  v-model="editedOffsetItem.SerialNumber.Number"
                                  @keyup.enter="focusNextInput"
                                  disabled
                                  :label="$t('quotation_item_serialnumber')"
                                >
                                </v-text-field>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_price')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedOffsetItem.Price"
                                    :error-messages="errors[0]"
                                    @change="changeMoney"
                                    @keyup.enter="focusNextInput"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_price') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  name="折扣"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedOffsetItem.Discount"
                                    :error-messages="errors[0]"
                                    @change="changeMoney"
                                    @keyup.enter="focusNextInput"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      折扣
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  name="折扣後單價"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedOffsetItem.DiscountPrice"
                                    :error-messages="errors[0]"
                                    disabled
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      折扣後單價
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_total_price')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="computedTotalPrice"
                                    :error-messages="errors[0]"
                                    disabled
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_total_price') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_warranty_period')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedOffsetItem.WarrantyPeriod"
                                    :error-messages="errors[0]"
                                    @keyup.enter="focusNextInput"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_warranty_period') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <v-autocomplete
                                  v-model="editedOffsetItem.InstallPosition"
                                  :items="allInstallPositionType"
                                  item-text="Name"
                                  item-value="Type"
                                  :label="$t('quotation_item_install_position')"
                                  :loading-text="$t('common_get_data')"
                                  :no-data-text="$t('common_no_results')"
                                  @keyup.enter="focusNextInput"
                                ></v-autocomplete>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_repair_price')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedOffsetItem.RepairPrice"
                                    :error-messages="errors[0]"
                                    disabled
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_repair_price') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_repair_warranty_period')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedOffsetItem.RepairWarrantyPeriod"
                                    :error-messages="errors[0]"
                                    disabled
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_repair_warranty_period') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <v-textarea
                                  outlined
                                  :label="$t('quotation_item_remark')"
                                  v-model="editedOffsetItem.Remark"
                                ></v-textarea>
                              </v-col>
                            </v-row>
                          </ValidationObserver>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click="closeEditedOffsetItem">
                          {{ $t('common_cancel') }}
                        </v-btn>
                        <v-btn color="green darken-1" text @click="saveEditedOffsetItem">
                          {{ $t('common_save') }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-btn
                    color="primary"
                    class="mb-2 ml-8"
                    @click="isShowOffsetEditedBomDialog = true"
                    :disabled="isAllTextFieldDisabled || quotationNumberType === numberType.Repair"
                  >
                    {{ $t('quotation_item_new_install_new_bom_btn') }}
                  </v-btn>
                  <v-dialog
                    v-if="isShowOffsetEditedBomDialog"
                    v-model="isShowOffsetEditedBomDialog"
                    persistent
                  >
                    <v-card>
                      <v-card-title>
                        <span class="text-h5"></span>
                      </v-card-title>

                      <v-card-text>
                        <v-container>
                          <ValidationObserver ref="bomRepairItem">
                            <v-row>
                              <v-col cols="12" sm="6" md="4" xl="3" lg="3">
                                <v-checkbox
                                  v-model="editedOffsetBomItem.IsCustomerDevice"
                                  :label="$t('quotation_item_is_customer_device')"
                                  @change="changeIsCustomerDevice"
                                ></v-checkbox>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <v-autocomplete
                                  v-model="editedOffsetBomItem.CustomerDeviceType"
                                  :items="computedBomCustomerDeviceTypeList"
                                  item-text="Name"
                                  item-value="Type"
                                  :label="$t('engineer_item_customer_device_type')"
                                  :loading-text="$t('common_get_data')"
                                  :no-data-text="$t('common_no_results')"
                                  v-if="editedOffsetBomItem.IsCustomerDevice"
                                  ref="deviceTypeAutocomplete"
                                  @keyup.enter="setCustomerDeviceType"
                                ></v-autocomplete>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <quotation-bom-for-repair-price-autocomplete
                                  :fatherEditedItem="editedOffsetBomItem"
                                  :editedItemIndex="editedOffsetItemIndex"
                                  :itemName="'quotation_item_number'"
                                  :repairCustomerId="customerId"
                                  :customerDeviceType="editedOffsetBomItem.CustomerDeviceType"
                                  @setBomItem="setBomItem"
                                  v-if="editedOffsetItemIndex === -1"
                                  @keyupEnter="focusNextInput"
                                  refName="bomNameAutocomplete"
                                />
                              </v-col>
                              <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                                <v-text-field
                                  v-model="editedOffsetBomItem.Describe"
                                  disabled
                                  label="主設備描述"
                                >
                                </v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('installation_notice_item_buy_or_rent')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-autocomplete
                                    v-model="editedOffsetBomItem.BuyOrRentType"
                                    :items="allBuyOrRentType"
                                    item-text="Name"
                                    item-value="Type"
                                    required
                                    :loading-text="$t('common_get_data')"
                                    :no-data-text="$t('common_no_results')"
                                    ref="buyOrRentTypeAutocomplete"
                                    @keyup.enter="setBuyOrRentType"
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('installation_notice_item_buy_or_rent') }}
                                    </template>
                                  </v-autocomplete>
                                </ValidationProvider>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_quantity')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedOffsetBomItem.Quantity"
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_quantity') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                                <v-autocomplete
                                  v-model="editedOffsetBomItem.InstallPositions"
                                  :items="allInstallPositionType"
                                  item-text="Name"
                                  item-value="Type"
                                  :label="$t('quotation_item_install_position')"
                                  :loading-text="$t('common_get_data')"
                                  :no-data-text="$t('common_no_results')"
                                  small-chips
                                  multiple
                                  @change="setInstallPositionListQuantity"
                                ></v-autocomplete>
                              </v-col>
                            </v-row>
                          </ValidationObserver>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="red darken-1"
                          text
                          @click="closeOffsetEditedBomDialog"
                          :disabled="isAllTextFieldDisabled"
                        >
                          {{ $t('common_cancel') }}
                        </v-btn>
                        <v-btn color="green darken-1" text @click="addOffsetBomItem">
                          {{ $t('common_confirm') }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <delete-dialog
                    :isAllTextFieldDisable="false"
                    :isLoadingSaveBtn="false"
                    :isShowDeleteDialog="isShowDeleteOffsetItemDialog"
                    :deleteMessage="'quotation_item_remove_car_customer_fix_delete_title'"
                    @closeDelete="closeDeleteOffsetItem"
                    @confirmDelete="confirmDeleteOffsetItem"
                  />
                </v-toolbar>
              </template>
              <template v-slot:[`item.Edit`]="{ item }">
                <v-icon
                  small
                  @click="isShowEditedOffsetItemDialogBtn(item)"
                  :disabled="isAllTextFieldDisabled"
                >
                  mdi-pencil
                </v-icon>
                <v-icon
                  small
                  @click="isShowDeleteOffsetItemDialogBtn(item)"
                  :disabled="isAllTextFieldDisabled"
                >
                  mdi-delete
                </v-icon>
              </template>
              <template v-slot:[`item.InstallPosition`]="{ item }">
                {{ turnData(item.InstallPosition) }}
              </template>
              <template v-slot:[`item.BuyOrRentType`]="{ item }">
                {{ turnBuyOrRentType(item.BuyOrRentType) }}
              </template>
              <template v-slot:[`item.Move`]="{ item, index }">
                <v-btn
                  icon
                  @click="upOffsetItem(item)"
                  v-if="index !== 0"
                  :disabled="isAllTextFieldDisabled"
                >
                  <v-icon>
                    mdi-arrow-up-drop-circle-outline
                  </v-icon>
                </v-btn>
                <v-btn
                  icon
                  @click="downOffsetItem(item)"
                  v-if="index !== computedOffsetItemList.length - 1"
                  :disabled="isAllTextFieldDisabled"
                >
                  <v-icon>
                    mdi-arrow-down-drop-circle-outline
                  </v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item value="tab-2">
        <v-card flat>
          <v-card-text>
            <v-data-table
              :headers="payItemDataTableHeaders"
              :items="payItemList"
              :search="searchPayItem"
              class="elevation-1"
              :no-data-text="$t('common_no_data')"
              :no-results-text="$t('common_no_results')"
              item-key="Name"
              disable-pagination
              hide-default-footer
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <v-toolbar-title> </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="searchPayItem"
                    append-icon="mdi-magnify"
                    :label="$t('quotation_item_new_install_search')"
                    single-line
                    hide-details
                    clearable
                  ></v-text-field>
                  <v-btn
                    color="primary"
                    class="mb-2 ml-8"
                    :disabled="isAllTextFieldDisabled"
                    @click="openPayItem"
                  >
                    {{ $t('quotation_item_new_install_new_item_btn') }}
                  </v-btn>
                  <v-dialog
                    v-model="isShowEditPayItemDialog"
                    v-if="isShowEditPayItemDialog"
                    persistent
                  >
                    <v-card>
                      <v-card-title>
                        <span class="text-h5">{{ $t('quotation_item_return_pay') }}</span>
                      </v-card-title>
                      <v-card-text>
                        <v-container>
                          <ValidationObserver ref="dialogPayItem">
                            <v-row>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <pay-item-autocomplete
                                  :fatherEditedItem="editedPayItem"
                                  :editedItemIndex="editedPayItemIndex"
                                  :itemName="'quotation_item_number'"
                                  @setEditedPayItem="setEditedPayItem"
                                  v-if="editedPayItemIndex === -1"
                                  refName="payItemAutocomplete"
                                  @keyupEnter="focusNextInput"
                                />
                                <ValidationProvider
                                  :name="$t('quotation_item_number')"
                                  rules="required"
                                  v-slot="{ errors }"
                                  v-else
                                >
                                  <v-text-field
                                    v-model="editedPayItem.Number"
                                    disabled
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_number') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_name')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedPayItem.Name"
                                    disabled
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_name') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_car_quantity')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedPayItem.BuyQuantity"
                                    :error-messages="errors[0]"
                                    @change="changePayTotal"
                                    disabled
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_car_quantity') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_unit')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedPayItem.Unit"
                                    disabled
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_unit') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_price')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedPayItem.Price"
                                    :error-messages="errors[0]"
                                    @change="changePayTotal"
                                    @keyup.enter="focusNextInput"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_price') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  name="折扣"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedPayItem.Discount"
                                    :error-messages="errors[0]"
                                    @change="changePayTotal"
                                    @keyup.enter="focusNextInput"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      折扣
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  name="折扣後單價"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedPayItem.DiscountPrice"
                                    :error-messages="errors[0]"
                                    disabled
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      折扣後單價
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_total_price')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedPayItem.TotalPrice"
                                    :error-messages="errors[0]"
                                    disabled
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_total_price') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <v-textarea
                                  outlined
                                  :label="$t('quotation_item_remark')"
                                  v-model="editedPayItem.Remark"
                                ></v-textarea>
                              </v-col>
                            </v-row>
                          </ValidationObserver>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click="closeEditedPayItem">
                          {{ $t('common_cancel') }}
                        </v-btn>
                        <v-btn color="green darken-1" text @click="saveEditedPayItem">
                          {{ $t('common_save') }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <delete-dialog
                    :isAllTextFieldDisable="false"
                    :isLoadingSaveBtn="false"
                    :isShowDeleteDialog="isShowDeletePayItemDialog"
                    :deleteMessage="'quotation_item_delete_item_dialog_title'"
                    @closeDelete="closeDeletePayItem"
                    @confirmDelete="confirmDeletePayItem"
                  />
                </v-toolbar>
              </template>
              <template v-slot:[`item.Edit`]="{ item }">
                <v-btn
                  icon
                  @click="isShowEditPayItemDialogBtn(item)"
                  :disabled="isAllTextFieldDisabled"
                >
                  <v-icon small>
                    mdi-pencil
                  </v-icon>
                </v-btn>
                <v-btn
                  icon
                  @click="isShowDeletePayItemDialogBtn(item)"
                  :disabled="isAllTextFieldDisabled"
                >
                  <v-icon small>
                    mdi-delete
                  </v-icon>
                </v-btn>
              </template>
              <template v-slot:[`item.Move`]="{ item, index }">
                <v-btn
                  icon
                  @click="upPayItem(item)"
                  v-if="index !== 0"
                  :disabled="isAllTextFieldDisabled"
                >
                  <v-icon>
                    mdi-arrow-up-drop-circle-outline
                  </v-icon>
                </v-btn>
                <v-btn
                  icon
                  @click="downPayItem(item)"
                  v-if="index !== payItemList.length - 1"
                  :disabled="isAllTextFieldDisabled"
                >
                  <v-icon>
                    mdi-arrow-down-drop-circle-outline
                  </v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import { HttpInstallPosition, HttpQuotation, HttpInstallationAcceptance } from '@/js/http-Manager'
import { extend } from 'vee-validate'
import { regex } from 'vee-validate/dist/rules'
import { ItemInstallPositionType } from '@/js/ItemInstallPositionType'
import { NumberType } from '@/js/NumberType'
import { BuyOrRentType } from '@/js/BuyOrRentType'
import DeleteDialog from '@/components/DeleteDialog.vue'
import PayItemAutocomplete from '@/components/PayItemAutocomplete.vue'
import QuotationItemForRepairPriceAutocomplete from '@/components/Quotation/ItemAutocomplete/QuotationItemForRepairPriceAutocomplete.vue'
import QuotationBomForRepairPriceAutocomplete from '@/components/Quotation/BomAutocomplete/QuotationBomForRepairPriceAutocomplete.vue'

extend('regex', regex)

export default {
  components: {
    DeleteDialog,
    PayItemAutocomplete,
    QuotationItemForRepairPriceAutocomplete,
    QuotationBomForRepairPriceAutocomplete
  },
  name: 'Repair',
  data: () => ({
    numberType: NumberType,
    selectedOffsetItems: [],
    isShowDeleteOffsetItemDialog: false,
    editedOffsetItemIndex: -1,
    searchOffsetItem: '',
    isShowEditOffsetItemDialog: false,
    editedOffsetItem: {
      BomName: '',
      Number: '',
      Name: '',
      Quantity: 0,
      BuyOrRentType: 1,
      Unit: '',
      SerialNumber: {
        ItemId: '',
        Number: '',
        IsUsed: false,
        AcceptanceNumber: '',
        RepairNumber: ''
      },
      Price: 0,
      TotalPrice: 0,
      WarrantyPeriod: 0,
      InstallPosition: 0,
      IsCustomerDevice: false,
      CustomerDeviceType: 0,
      Remark: '',
      DiscountPrice: 0,
      Discount: 0
    },
    defaultOffsetItem: {
      BomName: '',
      Number: '',
      Name: '',
      Quantity: 0,
      BuyOrRentType: 1,
      Unit: '',
      SerialNumber: {
        ItemId: '',
        Number: '',
        IsUsed: false,
        AcceptanceNumber: '',
        RepairNumber: ''
      },
      Price: 0,
      TotalPrice: 0,
      WarrantyPeriod: 0,
      InstallPosition: 0,
      IsCustomerDevice: false,
      CustomerDeviceType: 0,
      Remark: '',
      DiscountPrice: 0,
      Discount: 0
    },
    allInstallPositionType: [],
    customerDeviceTypeList: [],
    allBuyOrRentType: [],
    computedTotalPrice: 0,
    regexPrice: /^-[0-9]+$|^[0-9]+$/,
    regexQuantity: /^[0-9]+$/,
    searchPayItem: '',
    isShowEditPayItemDialog: false,
    editedPayItem: {
      Id: '',
      Number: '',
      Name: '',
      BuyQuantity: 0,
      Unit: '',
      Price: 0,
      DiscountPrice: 0,
      Discount: 0,
      Remark: '',
      TotalPrice: 0
    },
    defaultPayItem: {
      Id: '',
      Number: '',
      Name: '',
      BuyQuantity: 0,
      Unit: '',
      Price: 0,
      DiscountPrice: 0,
      Discount: 0,
      Remark: '',
      TotalPrice: 0
    },
    editedPayItemIndex: -1,
    isShowDeletePayItemDialog: false,
    isShowOffsetEditedBomDialog: false,
    editedOffsetBomItem: {
      Name: '',
      Describe: '',
      BuyOrRentType: 1,
      Quantity: 1,
      InstallPositions: [],
      BomItems: [],
      IsCustomerDevice: false,
      CustomerDeviceType: 0
    },
    defaultOffsetBomItem: {
      Name: '',
      Describe: '',
      BuyOrRentType: 1,
      Quantity: 1,
      InstallPositions: [],
      BomItems: [],
      IsCustomerDevice: false,
      CustomerDeviceType: 0
    }
  }),
  async mounted () {
    await this.getBuyOrRentType()
    await this.getAllInstallPositionType()
    await this.getCustomerDeviceType()
  },
  computed: {
    offsetItemDataTableHeaders () {
      return [
        { text: this.$t('bom_name'), align: 'start', value: 'BomName' },
        { text: this.$t('quotation_item_number'), align: 'start', value: 'Number' },
        { text: this.$t('quotation_item_name'), align: 'start', value: 'Name' },
        { text: this.$t('quotation_item_quantity'), align: 'end', value: 'Quantity' },
        {
          text: this.$t('installation_notice_item_buy_or_rent'),
          align: 'center',
          value: 'BuyOrRentType'
        },
        {
          text: this.$t('quotation_item_serialnumber'),
          align: 'start',
          value: 'SerialNumber.Number'
        },
        { text: this.$t('quotation_item_unit'), align: 'start', value: 'Unit' },
        { text: this.$t('quotation_item_price'), align: 'end', value: 'Price' },
        { text: '折扣', align: 'end', value: 'Discount' },
        { text: '折扣後單價', align: 'end', value: 'DiscountPrice' },
        { text: this.$t('quotation_item_total_price'), align: 'end', value: 'TotalPrice' },
        { text: this.$t('quotation_item_warranty_period'), align: 'end', value: 'WarrantyPeriod' },
        {
          text: this.$t('quotation_item_install_position'),
          align: 'start',
          value: 'InstallPosition'
        },
        {
          text: this.$t('quotation_item_is_customer_device'),
          align: 'start',
          value: 'IsCustomerDevice'
        },
        { text: this.$t('quotation_item_repair_price'), align: 'end', value: 'RepairPrice' },
        {
          text: this.$t('quotation_item_repair_warranty_period'),
          align: 'end',
          value: 'RepairWarrantyPeriod'
        },
        { text: this.$t('quotation_item_remark'), align: 'start', value: 'Remark' },
        { text: this.$t('common_edit'), align: 'center', value: 'Edit', sortable: false },
        { text: '調動', align: 'center', value: 'Move', sortable: false }
      ]
    },
    title () {
      return this.editedOffsetItemIndex === -1 ? this.$t('common_new') : this.$t('common_edit')
    },
    payItemDataTableHeaders () {
      return [
        { text: this.$t('quotation_item_number'), align: 'start', value: 'Number' },
        { text: this.$t('quotation_item_name'), align: 'start', value: 'Name' },
        { text: this.$t('quotation_car_quantity'), align: 'end', value: 'BuyQuantity' },
        { text: this.$t('quotation_item_unit'), align: 'start', value: 'Unit' },
        { text: this.$t('quotation_item_price'), align: 'end', value: 'Price' },
        { text: '折扣', align: 'end', value: 'Discount' },
        { text: '折扣後單價', align: 'end', value: 'DiscountPrice' },
        { text: this.$t('quotation_item_total_price'), align: 'end', value: 'TotalPrice' },
        { text: this.$t('quotation_item_remark'), align: 'start', value: 'Remark' },
        { text: this.$t('common_edit'), align: 'center', value: 'Edit', sortable: false },
        { text: '調動', align: 'center', value: 'Move', sortable: false }
      ]
    },
    computedItemCustomerDeviceTypeList () {
      let array = []
      if (this.editedOffsetItem.Number.includes('RA400')) {
        array = this.customerDeviceTypeList.filter((x) => x.Type !== 3)
      } else if (this.editedOffsetItem.HasSerialNumber) {
        let obj = this.customerDeviceTypeList.find((x) => x.Type === 3)
        array.push(obj)
      } else {
        array = this.customerDeviceTypeList
      }

      return array
    },
    computedBomCustomerDeviceTypeList () {
      let array = []
      let isRA400 =
        this.editedOffsetBomItem.BomItems.findIndex((x) => x.Number.includes('RA400')) !== -1
      let hasSerialNumber =
        this.editedOffsetBomItem.BomItems.findIndex((x) => x.HasSerialNumber) !== -1
      if (isRA400) {
        array = this.customerDeviceTypeList.filter((x) => x.Type !== 3)
      } else if (hasSerialNumber) {
        let obj = this.customerDeviceTypeList.find((x) => x.Type === 3)
        array.push(obj)
      } else {
        array = this.customerDeviceTypeList
      }
      return array
    },
    computedOffsetItemList () {
      let array = []
      this.offsetList.forEach((element, index) => {
        array.push(Object.assign({ Index: index }, element))
      })
      return array
    }
  },
  watch: {},
  methods: {
    async addOffsetBomItem () {
      const isValid = await this.$refs.bomRepairItem.validate()
      if (isValid) {
        this.computedOffsetItemList.forEach((element) => {
          if (
            this.editedOffsetBomItem.Id === element.BomId &&
            this.editedOffsetBomItem.BuyOrRentType === element.BuyOrRentType
          ) {
            let index = this.editedOffsetBomItem.BomItems.findIndex((x) => x.Id === element.Id)
            if (index !== -1) {
              if (
                this.editedOffsetBomItem.InstallPositions &&
                this.editedOffsetBomItem.InstallPositions.length > 0
              ) {
                let idx = this.editedOffsetBomItem.InstallPositions.findIndex(
                  (x) => x === element.InstallPosition
                )
                if (idx !== -1) {
                  this.editedOffsetBomItem.InstallPositions.splice(idx, 1)
                  this.editedOffsetBomItem.Quantity--
                  if (this.editedOffsetBomItem.InstallPositions.length === 0) {
                    this.editedOffsetBomItem.BomItems.splice(index, 1)
                  }
                }
              } else {
                this.editedOffsetBomItem.BomItems.splice(index, 1)
              }
            }
          }
        })

        if (this.editedOffsetBomItem.BomItems.length !== 0) {
          if (
            this.editedOffsetBomItem.InstallPositions &&
            this.editedOffsetBomItem.InstallPositions.length > 0
          ) {
            this.editedOffsetBomItem.InstallPositions.forEach((ele) => {
              this.editedOffsetBomItem.BomItems.forEach((element) => {
                this.$emit('setOffsetItemIndex', -1)
                this.$emit('setEditedOffsetItem', {
                  BomName: this.editedOffsetBomItem.Name,
                  BomId: this.editedOffsetBomItem.Id,
                  BomDescribe: this.editedOffsetBomItem.Describe,
                  Id: element.Id,
                  Number: element.Number,
                  Name: element.Name,
                  Unit: element.Unit,
                  Quantity:
                    (element.Quantity * this.editedOffsetBomItem.Quantity * 1) /
                    this.editedOffsetBomItem.InstallPositions.length,
                  BuyOrRentType: this.editedOffsetBomItem.BuyOrRentType,
                  SerialNumber: {
                    ItemId: '',
                    Number: '',
                    IsUsed: false,
                    AcceptanceNumber: '',
                    RepairNumber: ''
                  },
                  IsCustomerDevice: this.editedOffsetBomItem.IsCustomerDevice,
                  InstallPosition: ele,
                  Custody: 0,
                  Remark: '',
                  HasSerialNumber: element.HasSerialNumber,
                  CustomerDeviceType: this.editedOffsetBomItem.CustomerDeviceType,
                  WarrantyPeriod: element.WarrantyPeriod,
                  RepairPrice: element.RepairPrice,
                  RepairWarrantyPeriod: element.RepairWarrantyPeriod,
                  Price: element.Price,
                  DiscountPrice: element.Price,
                  Discount: 0,
                  TotalPrice:
                    (element.Price * (element.Quantity * this.editedOffsetBomItem.Quantity * 1)) /
                    this.editedOffsetBomItem.InstallPositions.length
                })
              })
            })
          } else {
            this.editedOffsetBomItem.BomItems.forEach((element) => {
              this.$emit('setOffsetItemIndex', -1)
              this.$emit('setEditedOffsetItem', {
                BomName: this.editedOffsetBomItem.Name,
                BomId: this.editedOffsetBomItem.Id,
                BomDescribe: this.editedOffsetBomItem.Describe,
                Id: element.Id,
                Number: element.Number,
                Name: element.Name,
                Unit: element.Unit,
                Quantity: element.Quantity * this.editedOffsetBomItem.Quantity * 1,
                BuyOrRentType: this.editedOffsetBomItem.BuyOrRentType,
                SerialNumber: {
                  ItemId: '',
                  Number: '',
                  IsUsed: false,
                  AcceptanceNumber: '',
                  RepairNumber: ''
                },
                IsCustomerDevice: this.editedOffsetBomItem.IsCustomerDevice,
                InstallPosition: element.InstallPosition,
                Custody: 0,
                Remark: '',
                HasSerialNumber: element.HasSerialNumber,
                CustomerDeviceType: this.editedOffsetBomItem.CustomerDeviceType,
                WarrantyPeriod: element.WarrantyPeriod,
                RepairPrice: element.RepairPrice,
                RepairWarrantyPeriod: element.RepairWarrantyPeriod,
                Price: element.Price,
                DiscountPrice: element.Price,
                Discount: 0,
                TotalPrice:
                  element.Price * element.Quantity * this.editedOffsetBomItem.Quantity * 1
              })
            })
          }
        }

        this.closeOffsetEditedBomDialog()
      }
    },
    closeOffsetEditedBomDialog () {
      this.isShowOffsetEditedBomDialog = false
      this.editedOffsetBomItem = JSON.parse(JSON.stringify(this.defaultOffsetBomItem))
    },
    setCustomerDeviceType (event) {
      this.$refs.deviceTypeAutocomplete.isMenuActive = false
      this.$refs.deviceTypeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setInstallPositionListQuantity () {
      this.editedOffsetBomItem.Quantity = this.editedOffsetBomItem.InstallPositions.length
      this.editedOffsetBomItem = JSON.parse(JSON.stringify(this.editedOffsetBomItem))
    },
    setBomItem (val) {
      if (this.editedOffsetBomItem) {
        this.editedOffsetBomItem.Id = val.Id
        this.editedOffsetBomItem.Name = val.Name
        this.editedOffsetBomItem.Describe = val.Describe
        this.editedOffsetBomItem.BomItems = val.BomItems
        this.editedOffsetBomItem.BomItems.forEach((element) => {
          element.Price = element.RepairPrice
          element.WarrantyPeriod = element.RepairWarrantyPeriod
        })
      } else {
        this.editedOffsetBomItem.Id = ''
        this.editedOffsetBomItem.Name = ''
        this.editedOffsetBomItem.Describe = ''
        this.editedOffsetBomItem.BomItems = []
      }
      this.editedOffsetBomItem = JSON.parse(JSON.stringify(this.editedOffsetBomItem))
    },
    setBuyOrRentType (event) {
      this.$refs.buyOrRentTypeAutocomplete.isMenuActive = false
      this.$refs.buyOrRentTypeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    isShowDeleteOffsetItemDialogBtn (item) {
      this.editedOffsetItemIndex = this.computedOffsetItemList.indexOf(item)
      this.isShowDeleteOffsetItemDialog = true
    },
    confirmDeleteOffsetItem () {
      this.$emit('deleteOffsetItem', this.editedOffsetItemIndex)
      this.closeDeleteOffsetItem()
    },
    closeDeleteOffsetItem () {
      this.isShowDeleteOffsetItemDialog = false
      this.editedOffsetItemIndex = -1
    },
    setEditedItem (val) {
      this.editedOffsetItem.Id = val.Id
      this.editedOffsetItem.Number = val.Number
      this.editedOffsetItem.Name = val.Name
      this.editedOffsetItem.Unit = val.Unit
      this.editedOffsetItem.Price = val.RepairPrice
      this.editedOffsetItem.IsMonthItem = val.IsMonthItem
      this.editedOffsetItem.IsDelete = val.IsDelete
      this.editedOffsetItem.StoreNo = val.StoreNo
      this.editedOffsetItem.RepairPrice = val.RepairPrice
      this.editedOffsetItem.RepairWarrantyPeriod = val.RepairWarrantyPeriod
      this.editedOffsetItem.RentWarrantyPeriod = val.RentWarrantyPeriod
      this.editedOffsetItem.WarrantyPeriod = val.RepairWarrantyPeriod
      this.editedOffsetItem.HasSerialNumber = val.HasSerialNumber
      this.editedOffsetItem.Type = val.Type
      this.editedOffsetItem.BuyOrRentType =
        val.Type === 'Z100000000' ? 2 : this.editedOffsetItem.BuyOrRentType
      if (val.HasSerialNumber) {
        this.editedOffsetItem.Quantity = 1
      }
      this.editedOffsetItem = JSON.parse(JSON.stringify(this.editedOffsetItem))
      this.changeMoney()
    },
    setCustomerDevice (event) {
      this.$refs.customerDeviceTypeAutocomplete.isMenuActive = false
      this.$refs.customerDeviceTypeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    changeIsCustomerDevice () {
      if (this.editedOffsetItem.IsCustomerDevice) {
        this.editedOffsetItem.CustomerDeviceType = 3
      } else {
        this.editedOffsetItem.CustomerDeviceType = 0
      }
      if (this.editedOffsetBomItem.IsCustomerDevice) {
        this.editedOffsetBomItem.CustomerDeviceType = 3
      } else {
        this.editedOffsetBomItem.CustomerDeviceType = 0
      }
    },
    setEditedPayItem (val) {
      this.editedPayItem.Id = val.Id
      this.editedPayItem.Number = val.Number
      this.editedPayItem.Name = val.Name
      this.editedPayItem.Unit = val.Unit
      this.editedPayItem.Price = val.Price
      this.editedPayItem.IsDelete = val.IsDelete
      this.editedPayItem.StoreNo = val.StoreNo
      this.changePayTotal()
      this.editedPayItem = JSON.parse(JSON.stringify(this.editedPayItem))
    },
    closeEditedPayItem () {
      this.isShowEditPayItemDialog = false
      this.editedPayItem = JSON.parse(JSON.stringify(this.defaultPayItem))
      this.editedPayItemIndex = -1
    },
    openPayItem () {
      this.editedPayItem.BuyQuantity = this.carQuantity
      this.isShowEditPayItemDialog = true
    },
    isShowEditPayItemDialogBtn (item) {
      this.editedPayItemIndex = this.payItemList.indexOf(item)
      this.editedPayItem = JSON.parse(JSON.stringify(item))
      this.isShowEditPayItemDialog = true
    },
    async saveEditedPayItem () {
      const isValid = await this.$refs.dialogPayItem.validate()
      if (isValid) {
        this.$emit('setPayItemIndex', this.editedPayItemIndex)
        this.$emit('setPayItem', this.editedPayItem)
        this.closeEditedPayItem()
      }
    },
    isShowDeletePayItemDialogBtn (item) {
      this.editedPayItemIndex = this.payItemList.indexOf(item)
      this.isShowDeletePayItemDialog = true
    },
    closeDeletePayItem () {
      this.editedPayItemIndex = -1
      this.isShowDeletePayItemDialog = false
    },
    confirmDeletePayItem () {
      this.$emit('deletePayItem', this.editedPayItemIndex)
      this.closeDeletePayItem()
    },
    changePayTotal () {
      if (
        this.regexPrice.test(this.editedPayItem.Price) &&
        this.regexQuantity.test(this.editedPayItem.BuyQuantity) &&
        this.regexQuantity.test(this.editedPayItem.Discount) &&
        this.regexQuantity.test(this.editedPayItem.DiscountPrice)
      ) {
        this.editedPayItem.DiscountPrice = this.editedPayItem.Price - this.editedPayItem.Discount
        this.editedPayItem.TotalPrice =
          this.editedPayItem.BuyQuantity * this.editedPayItem.DiscountPrice * 1
      }
    },
    downPayItem (item) {
      let temp = JSON.parse(JSON.stringify(this.payItemList))
      let currentIndex = temp.findIndex((x) => x.Id === item.Id)
      let currentObj = JSON.parse(JSON.stringify(temp[currentIndex]))
      let nextObj = JSON.parse(JSON.stringify(temp[currentIndex + 1]))
      temp.splice(currentIndex + 1, 1, currentObj)
      temp.splice(currentIndex, 1, nextObj)
      this.$emit('setAllPay', temp)
    },
    upPayItem (item) {
      let temp = JSON.parse(JSON.stringify(this.payItemList))
      let currentIndex = temp.findIndex((x) => x.Id === item.Id)
      let currentObj = JSON.parse(JSON.stringify(temp[currentIndex]))
      let preObj = JSON.parse(JSON.stringify(temp[currentIndex - 1]))
      temp.splice(currentIndex - 1, 1, currentObj)
      temp.splice(currentIndex, 1, preObj)
      this.$emit('setAllPay', temp)
    },
    turnBuyOrRentType (val) {
      return BuyOrRentType.BuyOrRentTypeName(val)
    },
    async getBuyOrRentType () {
      let response = await HttpInstallationAcceptance.GetBuyOrRentTypes()
      this.allBuyOrRentType = response.status === 200 ? response.data.Data : []
    },
    changeMoney () {
      if (
        this.regexPrice.test(this.editedOffsetItem.Price) &&
        this.regexQuantity.test(this.editedOffsetItem.Quantity) &&
        this.regexPrice.test(this.editedOffsetItem.Discount) &&
        this.regexPrice.test(this.editedOffsetItem.DiscountPrice)
      ) {
        this.editedOffsetItem.DiscountPrice =
          this.editedOffsetItem.Price - this.editedOffsetItem.Discount
        this.computedTotalPrice =
          this.editedOffsetItem.DiscountPrice * this.editedOffsetItem.Quantity
        this.editedOffsetItem.TotalPrice = this.computedTotalPrice
      }
    },
    focusNextInput (event) {
      let form = document.getElementsByTagName('input')
      let targets = []
      for (let i = 0; i < form.length; i++) {
        if (
          form[i].type !== 'hidden' &&
          !form[i].disabled &&
          !form[i].readOnly &&
          form[i].type !== 'checkbox'
        ) {
          targets.push(form[i])
        }
      }
      let index = Array.prototype.indexOf.call(targets, event.target)
      if (index !== -1) {
        let next = index + 1
        if (next < targets.length) {
          targets[next].focus()
          targets[next].select()
        }
      }
    },
    downOffsetItem (item) {
      let temp = JSON.parse(JSON.stringify(this.computedOffsetItemList))
      let currentIndex = item.HasSerialNumber
        ? temp.findIndex(
          (x) =>
            x.Id === item.Id &&
              x.BomId === item.BomId &&
              x.InstallPosition === item.InstallPosition &&
              x.SerialNumber.Number === item.SerialNumber.Number
        )
        : temp.findIndex(
          (x) =>
            x.Id === item.Id &&
              x.BomId === item.BomId &&
              x.InstallPosition === item.InstallPosition
        )
      let currentObj = JSON.parse(JSON.stringify(temp[currentIndex]))
      let nextObj = JSON.parse(JSON.stringify(temp[currentIndex + 1]))
      temp.splice(currentIndex + 1, 1, currentObj)
      temp.splice(currentIndex, 1, nextObj)
      this.$emit('setOffsetItem', temp)
    },
    upOffsetItem (item) {
      let temp = JSON.parse(JSON.stringify(this.computedOffsetItemList))
      let currentIndex = item.HasSerialNumber
        ? temp.findIndex(
          (x) =>
            x.Id === item.Id &&
              x.BomId === item.BomId &&
              x.InstallPosition === item.InstallPosition &&
              x.SerialNumber.Number === item.SerialNumber.Number
        )
        : temp.findIndex(
          (x) =>
            x.Id === item.Id &&
              x.BomId === item.BomId &&
              x.InstallPosition === item.InstallPosition
        )
      let currentObj = JSON.parse(JSON.stringify(temp[currentIndex]))
      let preObj = JSON.parse(JSON.stringify(temp[currentIndex - 1]))
      temp.splice(currentIndex - 1, 1, currentObj)
      temp.splice(currentIndex, 1, preObj)
      this.$emit('setOffsetItem', temp)
    },
    turnData (value) {
      if (value) {
        return ItemInstallPositionType.getFormInstallPositionTypeName(
          value,
          this.allInstallPositionType
        )
      }
    },
    async getAllInstallPositionType () {
      let response = await HttpInstallPosition.GetAllInstallPosition()
      this.allInstallPositionType = response.status === 200 ? response.data.Data : []
    },
    async getCustomerDeviceType () {
      let response = await HttpQuotation.GetCustomerDeviceType()
      this.customerDeviceTypeList = response.status === 200 ? response.data.Data : 0
    },
    convertToDateTimeFormat (timestamp) {
      if (timestamp === 0) {
        return '-'
      } else {
        return this.$moment(new Date(timestamp)).format('YYYY-MM-DD')
      }
    },

    isShowEditedOffsetItemDialogBtn (item) {
      this.editedOffsetItemIndex = this.computedOffsetItemList.indexOf(item)
      this.editedOffsetItem = JSON.parse(JSON.stringify(item))
      this.computedTotalPrice = item.TotalPrice
      this.isShowEditOffsetItemDialog = true
    },
    async saveEditedOffsetItem () {
      const isValid = await this.$refs.dialog.validate()
      if (isValid) {
        this.$emit('setOffsetItemIndex', this.editedOffsetItemIndex)
        this.$emit('setEditedOffsetItem', this.editedOffsetItem)
        this.closeEditedOffsetItem()
      }
    },
    closeEditedOffsetItem () {
      this.isShowEditOffsetItemDialog = false
      this.$nextTick(() => {
        this.editedOffsetItem = JSON.parse(JSON.stringify(this.defaultOffsetItem))
        this.editedOffsetItemIndex = -1
        this.computedTotalPrice = 0
      })
    },
    deleteOffsetItems () {
      let array = []
      this.computedOffsetItemList.forEach((element) => {
        let isExist =
          this.selectedOffsetItems.findIndex(
            (x) =>
              x.BomName === element.BomName &&
              x.InstallPosition === element.InstallPosition &&
              x.Id === element.Id
          ) !== -1
        if (!isExist) {
          array.push(element)
        }
      })

      this.$emit('setRemoveOffsetItem', array)
      this.selectedOffsetItems = []
    }
  },
  props: [
    'offsetList',
    'isAllTextFieldDisabled',
    'customerId',
    'payItemList',
    'carQuantity',
    'quotationNumberType'
  ]
}
</script>
